import axios, { AxiosResponse } from 'axios';
import { IServiceResult } from '../../Interfaces/IServiceResult';
import { ServiceResult } from './ServiceResult';

import { con } from '../../../application/entity/Rutas';

export class SVCPostulante {
    public static async ObtienePostulaciones(
        rut: number,
        anoProceso: number,
        periodoProceso: number,
        codigoNegocio: number,
        codigoPrograma: string,
        codigoPlanificacion: number,
        idPeriodo: number,
        headers: any
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + 'PostPostulacionCarreraPorAlumno';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';

        await axios
            .post(url, {
                rut: rut,
                anoProceso: anoProceso,
                periodoProceso: periodoProceso,
                codigoNegocio: codigoNegocio,
                codigoPrograma: codigoPrograma,
                codigoPlanificacion: codigoPlanificacion,
                idPeriodo: idPeriodo
            }, { headers })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
    public static async ObtienePostulacionesPostExt(
        headers: any,
        rut: number,
        pasaporte: string,
        anoProceso: number,
        periodoProceso: number,
        codigoNegocio: number,
        codigoPrograma: string,
        codigoPlanificacion: number,
        idPeriodo: number,
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();

        const url: string = _ruta + 'PostPostulacionCarreraPostgradoExtensionPorAlumno';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';

        await axios
            .post(url, {
                rut: rut,
                pasaporte: pasaporte,
                anoProceso: anoProceso,
                periodoProceso: periodoProceso,
                codigoNegocio: codigoNegocio,
                codigoPrograma: codigoPrograma,
                codigoPlanificacion: codigoNegocio === 1 ? 0 : codigoPlanificacion,
                idPeriodo: idPeriodo,
            }, { headers })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneInstrucciones(
        codigoNegocio: number,
        codigoPrograma: string,
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + 'Instruccion/getInstruccion';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';
        await axios
            .get(url, {
                params: {
                    codigoNegocio: codigoNegocio,
                    codigoPrograma: codigoPrograma,
                },
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneCondiciones(rut: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + 'Condiciones/getBeneficioAutomatico';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';
        await axios
            .get(url, {
                params: {
                    rut: rut,
                },
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneEtapas(
        codigoNegocio: number,
        codigoPrograma: string,
        CodigoPlanificacionAcademica: number,
        rut: number,
        año: number,
        periodo: number,
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();

        const url: string = _ruta + 'Etapa/getEtapaProceso';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';
        await axios
            .post(url, {
                rut: rut,
                // 'ano': año,
                // 'periodo': periodo,
                codigoNegocio: codigoNegocio,
                codigoPrograma: codigoPrograma,
                CodigoPlanificacionAcademica: CodigoPlanificacionAcademica,
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
}
